import { applySitePrimaryColor } from './lib/colorTheme';
applySitePrimaryColor();

import * as $ from "jquery";
// import "bootstrap";
import retinajs from 'retinajs';
import { init, showReportDialog, browserTracingIntegration, browserProfilingIntegration, replayIntegration } from "@sentry/vue";

window.jQuery = $;
window.$ = $;


window.addEventListener('load', retinajs);

if (window.s.sentry?.enabled && window.s.sentry.sentry_vue_dsn) {
  init({
    dsn: window.s.sentry.sentry_vue_dsn,
    release: window.s.sentryRelease,
    environment: window.s.sentry.environment,
    beforeSend(event) {
      if (event.exception && event.event_id) {
        showReportDialog({ eventId: event.event_id });
      }
      return event;
    },
    integrations: [
      // Add browser profiling integration to the list of integrations
      browserTracingIntegration(),
      browserProfilingIntegration(),
      replayIntegration(),
      // Sentry.feedbackIntegration({
      //   colorScheme: "system",
      // }),
    ],
    tracesSampleRate: window.s.sentry.tracesSampleRate ?? 0.1,
    // tracePropagationTargets: ["staging", "http://apple.staging.venngo.com/"],
    profilesSampleRate: window.s.sentry.profilesSampleRate ?? 0.1,
    replaysSessionSampleRate: window.s.sentry.replaysSessionSampleRate ?? 0.1,
    replaysOnErrorSampleRate: window.s.sentry.replaysOnErrorSampleRate ?? 0.1,
    attachStacktrace: true,
  });
}
